/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExtendedUsdcGate } from './ExtendedUsdcGate';
import {
    ExtendedUsdcGateFromJSON,
    ExtendedUsdcGateFromJSONTyped,
    ExtendedUsdcGateToJSON,
} from './ExtendedUsdcGate';

/**
 * 
 * @export
 * @interface ExtendedPurchaseGate
 */
export interface ExtendedPurchaseGate {
    /**
     * Must pay the total price and split to the given addresses to unlock
     * @type {ExtendedUsdcGate}
     * @memberof ExtendedPurchaseGate
     */
    usdcPurchase: ExtendedUsdcGate;
}

/**
 * Check if a given object implements the ExtendedPurchaseGate interface.
 */
export function instanceOfExtendedPurchaseGate(value: object): value is ExtendedPurchaseGate {
    let isInstance = true;
    isInstance = isInstance && "usdcPurchase" in value && value["usdcPurchase"] !== undefined;

    return isInstance;
}

export function ExtendedPurchaseGateFromJSON(json: any): ExtendedPurchaseGate {
    return ExtendedPurchaseGateFromJSONTyped(json, false);
}

export function ExtendedPurchaseGateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtendedPurchaseGate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'usdcPurchase': ExtendedUsdcGateFromJSON(json['usdc_purchase']),
    };
}

export function ExtendedPurchaseGateToJSON(value?: ExtendedPurchaseGate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'usdc_purchase': ExtendedUsdcGateToJSON(value.usdcPurchase),
    };
}

